export interface ErrorInterceptor {
}
// error.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogService } from './services/dialog.service';
import { SKIP_GLOBAL_ERROR } from './http-context';
import { apiErrorMessage } from './api-error';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private dialogService: DialogService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Screens that render the failure themselves opt out, so the user
        // is not shown the same message inline and as a blocking modal.
        if (req.context.get(SKIP_GLOBAL_ERROR)) {
          return throwError(() => error);
        }
        // 401s belong to AuthInterceptor: on an expired access token it
        // refreshes and replays silently, so a "log in again" modal here —
        // this interceptor unwinds before AuthInterceptor — would fire on
        // every routine token rollover. A genuinely dead session is ended by
        // AuthInterceptor's toLogin(), which needs no dialog either.
        if (error.status === 401) {
          return throwError(() => error);
        }
        const message = apiErrorMessage(error, 'Something went wrong');
        this.dialogService.showDialog({
          title: 'Error',
          message,
          okText: 'OK'
        });
        return throwError(() => error);
      })
    );
  }
}
